import StoryHistoryItem from './StoryHistoryItem';

export default StoryHistoryItem;
